import { TextField } from '@fox/atoms/src/text-field';
import { tryParseJSONObject } from '@fox/atoms/utils';
import { FormRenderMode, QuestionStyleTypes } from '../../../../../form-runtime-context/contracts';
import { useFormRuntimeContext, useQuestionStyle } from '../../../../../form-runtime-context/form-runtime-context';
import { DataTableCustomFieldComponentArgs, RenderTextEditMetaProps } from '../helpers';

export const TextCustomField = ({ questionId, field, row, handleChange }: DataTableCustomFieldComponentArgs) => {
	const { formRenderMode } = useFormRuntimeContext();

	const val = row?.[field.fieldId] ?? '';

	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(QuestionStyleTypes.answer, {}, questionId);

	let textFieldProps;

	const { characterLimitLength, singleLine } = tryParseJSONObject<RenderTextEditMetaProps>(field.meta) ?? {};

	switch (singleLine) {
		case true:
			textFieldProps = {
				size: 'small'
			};
			break;

		case false:
		case undefined:
			textFieldProps = {
				size: 'medium',
				multiline: true,
				minRows: 3
			};
			break;
	}

	const maxLengthProps = characterLimitLength
		? {
				inputProps: {
					maxLength: characterLimitLength,
					disableUnderline: true
				},
				helperText: `${val.length}/${characterLimitLength} characters`
			}
		: {};

	return (
		<TextField
			{...textFieldProps}
			{...maxLengthProps}
			value={val}
			onChange={e => {
				if (formRenderMode === FormRenderMode.design) return;
				handleChange(e.target.value, row.rowId, field.fieldId);
			}}
			sx={{
				'.MuiInputBase-root': {
					color,
					fontSize,
					fontStyle,
					fontFamily,
					textDecoration,
					fontWeight
				},
				'input:focus, textarea': {
					border: '0',
					boxShadow: 'none'
				}
			}}
		/>
	);
};
